import React__default from 'react';
import _s from 'styled-components';
import Box from './Box.js';
import './useTheme.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Switch = ({
  onChange,
  testID,
  value,
  disabled
}) => {
  const handlePress = () => !disabled && onChange(!value);
  return /*#__PURE__*/React__default.createElement(Container, {
    "data-testid": testID,
    "data-value": value,
    onClick: handlePress
  }, /*#__PURE__*/React__default.createElement(Box, {
    borderColor: value ? 'transparent' : 'secondary',
    borderRadius: "round",
    borderStyle: "solid",
    borderWidth: "base",
    cursor: "pointer",
    height: "20px",
    padding: "xTiny",
    shapeFill: value ? 'secondary' : 'senary',
    transition: "0.3s all ease-in-out",
    width: "38px",
    opacity: disabled ? 0.5 : 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    borderRadius: "round",
    height: "20px",
    shapeFill: value ? 'septenary' : 'tertiary',
    transform: value ? 'translateX(20px)' : 'translateX(0px)',
    transition: "0.2s all ease",
    width: "20px"
  })));
};
const Container = styled.div``;
Switch.displayName = 'Switch';

export { Switch as default };
//# sourceMappingURL=Switch.js.map
